"use strict";

// import { KeyboardEvent } from 'react';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleADA = handleADA;
function handleADA(event, accessibilityType, callback) {
  if (event instanceof KeyboardEvent || event['key'] || event['keyCode']) {
    switch (accessibilityType) {
      case 'Link':
      case 'link':
        if (event.key === 'Enter' || event.keyCode === 13) {
          callback(event);
          break;
        }
        break;
      case 'Button':
      case 'button':
        if (event.key === 'Enter' || event.keyCode === 13 || event.key === ' ' || event.keyCode === 32) {
          callback(event);
          break;
        }
        break;
      case 'Checkbox':
      case 'checkbox':
        if (event.key === ' ' || event.keyCode === 32) {
          callback(event);
          break;
        }
        break;
      default:
        break;
    }
  }
}
